import { useState } from "react";
import { Sun, Moon, Languages } from "lucide-react";
import { lang, setLang, theme, applyTheme } from "../lib/i18n";

export default function HeaderToggles() {
  const [mode, setMode] = useState(theme);
  const flip = () => { const v = mode === "dark" ? "light" : "dark"; applyTheme(v); setMode(v); };
  return (
    <>
      <button data-testid="theme-toggle" onClick={flip} aria-label="Toggle light or dark mode" className="p-2 rounded-full hover:bg-white/10 transition-colors">{mode === "dark" ? <Sun size={18} /> : <Moon size={18} />}</button>
      <button data-testid="language-toggle" onClick={() => setLang(lang() === "te" ? "en" : "te")} aria-label="Change language" className="flex items-center gap-1 px-2 py-1.5 rounded-full hover:bg-white/10 transition-colors text-xs font-semibold">
        <Languages size={16} />{lang() === "te" ? "EN" : "తె"}
      </button>
    </>
  );
}
